import React from 'react';
import { BentoCard, BentoGrid } from './ui/bento-grid';
import { Inbox, Calendar, Send, Ticket } from 'lucide-react';

const AntixBentoGrid = () => {
  const bentoItems = [
    {
      name: "All your events in one place",
      Icon: Inbox,
      description: "Connect your Gmail or Outlook and Antix automatically finds your gig, festival and concert bookings. No manual entry, no missed nights out.",
      className: "col-span-3 lg:col-span-2",
      background: (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-purple-500 via-blue-500/90 to-transparent opacity-60" />
          <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay"
               style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\'/%3E%3C/svg%3E")' }} />
        </>
      ),
    },
    {
      name: "Your complete event calendar",
      Icon: Calendar,
      description: "See every booking with times, dates, and locations at a glance.",
      className: "col-span-3 lg:col-span-1",
      background: (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500 via-cyan-500/90 to-transparent opacity-60" />
          <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay"
               style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\'/%3E%3C/svg%3E")' }} />
        </>
      ),
    },
    {
      name: "Forward tickets by email",
      Icon: Send,
      description: "Receive forwarded tickets from friends directly into Antix, ready to access in one place.",
      className: "col-span-3 lg:col-span-1",
      background: (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-orange-500 via-red-500/90 to-transparent opacity-60" />
          <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay"
               style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\'/%3E%3C/svg%3E")' }} />
        </>
      ),
    },
    {
      name: "Tickets, ready when you are",
      Icon: Ticket,
      description: "Each event comes with instant ticket access alongside all the details. No more inbox panic in the queue.",
      className: "col-span-3 lg:col-span-2",
      background: (
        <>
          <div className="absolute inset-0 bg-gradient-to-br from-purple-500 via-orange-500/90 to-transparent opacity-60" />
          <div className="absolute inset-0 opacity-[0.15] mix-blend-overlay"
               style={{ backgroundImage: 'url("data:image/svg+xml,%3Csvg viewBox=\'0 0 400 400\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cfilter id=\'noiseFilter\'%3E%3CfeTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'4\' stitchTiles=\'stitch\'/%3E%3C/filter%3E%3Crect width=\'100%25\' height=\'100%25\' filter=\'url(%23noiseFilter)\'/%3E%3C/svg%3E")' }} />
        </>
      ),
    },
  ];

  return (
    <div id="features" className="py-20 md:px-6 bg-[#000000]">
      <div className="container mx-auto max-w-7xl">
        <div className="text-left mb-16">
          <h2 className="text-[36px] md:text-[48px] font-semibold text-white mb-4 leading-tight font-['Space_Grotesk']">
            Everything you need to live your music life, without the chaos.
          </h2>
          <p className="text-[20px] md:text-[24px] text-gray-300 max-w-4xl leading-relaxed">
            Antix pulls all your events, tickets, and plans into one place. From inbox to calendar to door entry, you'll always know what's happening, when, and where. So you can focus on the music, not the admin.
          </p>
        </div>
        
        <BentoGrid className="max-w-6xl mx-auto">
          {bentoItems.map((item) => (
            <BentoCard
              key={item.name}
              name={item.name}
              Icon={item.Icon}
              description={item.description}
              className={`${item.className} bg-transparent border border-white/10 hover:border-orange-accent/30 transition-all duration-300`}
              style={{
                boxShadow: 'inset 0 0 80px rgba(255, 255, 255, 0.08), inset 0 0 160px rgba(255, 255, 255, 0.04), inset 0 2px 8px rgba(255, 255, 255, 0.12)'
              }}
              background={item.background}
            />
          ))}
        </BentoGrid>
      </div>
    </div>
  );
};

export default AntixBentoGrid;